module.exports = __webpack_public_path__ + "static/media/pdx-floor-2.12908116.png";